import { render, staticRenderFns } from "./ProductCarousel.vue?vue&type=template&id=b3877618&scoped=true&"
import script from "./ProductCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductCarousel.vue?vue&type=style&index=0&id=b3877618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3877618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VCol,VContainer,VRow,VSheet})
